import { Flag2Outline, PathIcon } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Path];

const config: ContentConfigProps = {
  routes: {
    create: routes.PathCreator,
    edit: routes.PathEditor,
    duplicate: routes.PathDuplicate,
    manageDetails: routes.AdminPathDetails,
    details: routes.PathDetails,
  },
  label: { title, createDescription },
  icons: {
    Create: Flag2Outline,
    Icon: PathIcon,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
